import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Madrid`,
  location: {
    lat: 40.416775,
    lng: -3.70379,
  },
  drivers: {
    label: [`Aaron`, `Martín`, `Pablo`],
    start_address: [
      `Calle de San Bernardo, 15, 28015, Madrid, España`,
      `Calle de San Bernardo, 15, 28015, Madrid, España`,
      `Calle de San Bernardo, 15, 28015, Madrid, España`,
    ],
    end_address: [
      `Calle de Bravo Murillo, 6, 28015, Madrid, España`,
      `Calle de San Bernardo, 15, 28015, Madrid, España`,
      `Calle de San Bernardo, 15, 28015, Madrid, España`,
    ],
  },
};

const stops: IExampleLocation = {
  name: `Madrid`,
  location: {
    lat: 40.416775,
    lng: -3.70379,
  },
  stops: {
    label: [
      `Taberna Arzábal`,
      `Fismuler`,
      `Latasia`,
      `Verdejo`,
      `Bacira`,
      `La bien aparecida`,
      `Las Carboneras`,
      `Restaurante Las Mañanitas`,
      `Ronda 14`,
      `Viva Madrid`,
    ],
    address: [
      `Calle del Dr. Castelo, 2, 28009, Madrid, España`,
      `Calle de Sagasta, 29, 28004, Madrid, España`,
      `Paseo de la Castellana, 115, 28046, Madrid, España`,
      `Calle de Espartinas, 6, 28001, Madrid, España`,
      `Calle del Castillo, 16, 28010, Madrid, España`,
      `Calle de Jorge Juan, 8, 28001, Madrid, España`,
      `Calle del Conde de Miranda, 1, 28005, Madrid, España`,
      `Calle de Fuencarral, 82, 28004, Madrid, España`,
      `Calle del Gral Oraá, 25, 28006, Madrid, España`,
      `Calle de Manuel Fernández y González, 7, 28014, Madrid, España`,
    ],
    address_details: [``, ``, `Piso 1 Puerta 3`, ``, `4º 5ª`, ``, `2ºB`, ``, ``, `4F`],
    delivery_label: [
      `Marc Navarro`,
      `Júlia Arroyo`,
      `Irene Dalmases`,
      `Adrià Ballester`,
      `Manuel Braz`,
      `Sonia Romero`,
      `Berta Sierra`,
      `Marc Horrillo`,
      `Purificación Molinos`,
      `Ramón Vega`,
    ],
    delivery_address: [
      `Calle de la Basílica, 20, 28020, Madrid, España`,
      `Calle de Goya, 7, 28001, Madrid, España`,
      `Av. del Mediterráneo, 17, 28007, Madrid, España`,
      `Avenida de América, 14, 28028, Madrid, España`,
      `Calle de Antonio Arias, 7, 28009, Madrid, España`,
      `Calle de Diego de León, 39, 28006, Madrid, España`,
      `Calle de Génova, 12, Piso 1º B, 28004, Madrid, España`,
      `Calle de Orense, 10, 28020, Madrid, España`,
      `Calle de Joaquín Costa, 26, 28002, Madrid, España`,
      `Calle de Goya, 7, 28001, Madrid, España`,
    ],
    delivery_address_details: [``, `4º 5ª esc. C`, ``, ``, `6º 1ª`, ``, `Bajos 1`, ``, ``, `Local`],
  },
};

export { drivers, stops };
